import PrivacyManagement from '../components/PrivacyManagement'
import { privacyManagementServiceConfig } from './shared/config'

import injectWidget from './shared/injectWidget'

const PrivacyManagementWidget = injectWidget({
  widget: PrivacyManagement,
  serviceConfig: privacyManagementServiceConfig,
})

export default PrivacyManagementWidget
